export function toCurrency(value,decimals=2) {
    if (value === undefined) {
        return '';
    }
    
    let number = parseFloat(value).toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return number;
}